// React
import React from 'react'
import validator from 'validator'
// GraphQL
import { compose, graphql } from 'react-apollo'
// GraphQL mutations
import { accountSignup, accountAuthenticate, emailConfirm, emailConfirmAgain } from '../../graphql/mutations/account'
// Components
import Button from '../Display/Button'
import HomeButton from '../Nav/HomeButton'
import Input from '../Display/Input'
import Loading from '../Display/Loading'
import Logo from '../Display/Logo'
import Modal from '../Display/Modal'

class Signin extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			authProcess: 'login',
			nameFirst: '',
			nameLast: '',
			email: '',
			password: '',
			passwordConfirm: '',
			confirm: { email: '', token: '' },
			loading: { status: false, text: '' },
			message: { text: '', color: '' },
			modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null }, loading: false }
		}
	}


	// CONFIRM EMAIL
	componentWillMount() {
		const email = window.localStorage.getItem('MoonSignApp:email') ? window.localStorage.getItem('MoonSignApp:email') : ''
		this.setState({ email })
		// Set state with url email and token, if any: https://mywebsite.com/reset?token=TOKEN&email=EMAIL
		let query = Object.assign({}, ...window.location.search.slice(1).split('&').map(item => {
			const property = item.split('=')[0]
			return { [property]: item.split('=')[1] }
		}))
		if (query.email && query.token) {
			this.setState({
				authProcess: 'confirming',
				confirm: { email: query.email, token: query.token },
				loading: { status: true, text: 'Confirming email...' }
			})
			this.props.emailConfirm({ variables: { accountConfirmedToken: query.token } })
				.then(() => {
					this.setState({
						authProcess: 'confirmed',
						email: query.email,
						loading: { status: false, text: '' },
						message: { text: 'Account confirmed. Please sign in.', color: '#008000' }
					})
					window.history.pushState('', '', '/')
				})
				.catch((err) => this.errorHandling(err))
		}
	}


	// FUNCTIONS
	userAuthenticate = () => {
		const { email, password } = this.state
		this.setState({ loading: { status: true, text: 'please wait....' } })
		this.props.accountAuthenticate({ variables: { email, password } })
			.then(({ data }) => {
				const loginApp = () => {
					window.localStorage.setItem('MoonSignApp:login', data.accountAuthenticate.token)
					window.history.pushState('', '', '/')
					window.location.reload()
				}
				// If on web, ask to save login data
				if (process.env.REACT_APP_ENV === 'web') {
					// If email has never been saved before, or if entered email is different, ask.
					if (!window.localStorage.getItem('MoonSignApp:account') || email !== window.localStorage.getItem('MoonSignApp:account')) {
						const actionFunc = () => {
							window.localStorage.setItem('MoonSignApp:account', email)
							loginApp()
						}
						const cancelFunc = () => {
							window.localStorage.removeItem('MoonSignApp:account')
							loginApp()
						}
						this.openModal('Stay logged in?', 'Select ‘no’ if you’re on a public computer or are using another person’s mobile device.', 'Yes', actionFunc, 'No', cancelFunc)
					}
					else {
						loginApp()
					}
				}
				// If on devices like iOS, Android, or macOS, always save email
				else {
					window.localStorage.setItem('MoonSignApp:account', email)
					loginApp()
				}
			})
			.catch((err) => this.errorHandling(err))
	}

	userSignup = () => {
		const { email, password, nameFirst, nameLast } = this.state
		this.setState({ loading: { status: true, text: 'please wait....' } })
		this.props.accountSignup({ variables: { email, password, nameFirst, nameLast } })
			.then(() => {
				this.openModal('Confirm Your Email', 'Please check your email for a confirmation link, which expires in 24 hours. If you entered an incorrect email address or don’t have access to it, please re-register using a different email address.', 'Continue', () => this.userAuthenticate())
			})
			.catch((err) => this.errorHandling(err))
	}

	errorHandling = (err) => {
		this.setState({ loading: { status: false, text: '' } })
		const errorMessage = err.toString().split(':')
		let actionFunc, cancelFunc
		switch (errorMessage[errorMessage.length-1].substr(1)) {
			case 'Account not confirmed':
				actionFunc = () => {
					this.setState({ loading: { status: true, text: 'please wait....' } })
					this.props.emailConfirmAgain({ variables: { email: this.state.email } })
						.then(() => this.openModal('Confirm account', 'Please check your email and click the confirmation link inside the email to confirm your account.', 'Continue'))
				}
				cancelFunc = () => this.resetAuthProcess()
				this.openModal('Confirm account', 'Your email has not yet been confirmed. Would you like us to send a confirmation link to your email address?', 'Yes', actionFunc, 'No', cancelFunc)
				break
			case 'No such user':
				this.setState({ authProcess: 'registration', loading: { status: false, text: '' } })
				break
			case '':
				this.setState({ authProcess: 'registration', loading: { status: false, text: '' } })
				break
			case 'Token expired':
				actionFunc = () => {
					this.setState({ loading: { status: true, text: 'please wait....' } })
					this.props.emailConfirmAgain({ variables: { email: this.state.email } })
						.then(() => {
							this.openModal(this.state.email, 'Please check your email and click the confirmation link inside the email to confirm your account.', 'Continue', () => this.resetAuthProcess())
						})
						.catch((err) => {
							this.openModal('Error', 'Please contact customer support at support@consciousapps.com for further assistance.', 'Continue', () => this.resetAuthProcess())
						})
				}
				cancelFunc = () => this.resetAuthProcess()
				this.openModal('Token Expired', 'Your email has to be confirmed within 24 hours. Would you like us to send a new confirmation link to your email address?', 'Yes', actionFunc, 'No', cancelFunc)
				break
			default:
				actionFunc = () => {
					this.resetAuthProcess()
					window.history.pushState('', '', '/')
				}
				this.openModal('Error', 'Please contact customer support.', 'Continue', actionFunc)
				console.log(err)
		}
	}

	resetAuthProcess = () => {
		this.setState({
			authProcess: 'login',
			nameFirst: '',
			nameLast: '',
			email: window.localStorage.getItem('MoonSignApp:account') ? window.localStorage.getItem('MoonSignApp:account') : '',
			password: '',
			passwordConfirm: '',
			loading: { status: false, text: '' }
		})
	}


	// MODALS
	openModal = (title, text, actionText, actionFunc, cancelText, cancelFunc) => {
		this.setState({
			loading: { status: false, text: '' },
			modal: {
				status: 'visible',
				title,
				text,
				action: {
					text: actionText,
					func: () => {
						this.closeModal()
						actionFunc()
					}
				},
				cancel: {
					text: cancelText,
					func: () => {
						this.closeModal()
						cancelFunc()
					}
				},
				loading: false
			}
		})
	}

	closeModal = () => this.setState({ modal: { status: 'hidden', title: '', text: '', action: { text: '', func: () => null }, cancel: { text: '', func: () => null } } })


	// OTHER
	validation = () => {
		const { authProcess, nameFirst, nameLast, email, password, passwordConfirm, } = this.state
		switch (authProcess) {
		case 'login':					return validator.isEmail(email) && password.length >= 6
		case 'registration':	return validator.isEmail(email) && password.length >= 6 && passwordConfirm.length >= 6 && password.length === passwordConfirm.length && nameFirst.length >= 1 && nameLast.length >= 1
		default:							return validator.isEmail(email) && password.length >= 6
		}
	}


	// INPUT HANDLERS
	handleInput = (name, value) => this.setState({ [name]: value })

	handleKeyPress = (target) => {
		if (target.charCode === 13 && this.validation()) {
			switch (this.state.authProcess) {
			case 'login':					this.userAuthenticate(); break
			case 'registration':	this.userSignup(); break
			default: this.userAuthenticate()
			}
		}
	}

	handleSelect = (e) => this.setState({ [e.name]: parseInt(e.newValue, 10) })


	render() {
		const { authProcess, nameFirst, nameLast, email, password, passwordConfirm, loading, message, modal } = this.state
		let buttonText
		let buttonFunc
		switch (authProcess) {
		case 'login':
			buttonText = 'Sign up or sign in'
			buttonFunc = this.validation() ? () => this.userAuthenticate() : null
			break
		case 'registration':
			buttonText = this.validation() ? 'Sign up' : 'Complete signup'
			buttonFunc = this.validation() ? () => this.userSignup() : null
			break
		case 'confirm':
			buttonText = 'Continue'
			buttonFunc = () => this.resetAuthProcess()
			break
		case 'confirmed':
			buttonText = 'Sign in'
			buttonFunc = this.validation() ? () => this.userAuthenticate() : null
			break
		default:
			buttonText = 'Sign up or sign in for free'
			buttonFunc = this.validation() ? () => this.userAuthenticate() : null
		}
		return (
			<div className='capps-container'>
				<HomeButton {...this.props} />
				<Loading status={loading.status} text={loading.text} />
				<Modal
					status={modal.status}
					title={modal.title}
					text={modal.text}
					action={{ text: modal.action.text, func: modal.action.func }}
					cancel={{ text: modal.cancel.text, func: modal.cancel.func }}
					loading={modal.loading}
				/>

				{/* HEADER */}
				<Logo {...this.props} />
				{authProcess === 'login' &&
					<div className='capps-footer'>
						Create a free account to use this app’s advanced features at <a href='https://www.MoonSignApp.com' target='_new' className='capps-link'>MoonSignApp.com</a>
						{/* Create a free account to use this app’s advanced features on <a href='http://ios.MoonSignApp.com' target='_new' className='capps-link'>iOS</a>, <a href='http://play.MoonSignApp.com' target='_new' className='capps-link'>Android</a>, or on the web at <a href='https://www.MoonSignApp.com' target='_new' className='capps-link'>MoonSignApp.com</a> */}
					</div>
				}

				{/* AUTHENTICATION */}
				{(authProcess === 'login' || authProcess === 'registration' || authProcess === 'confirmed') &&
					<div>
						<Input
							focus={true}
							label='Email'
							name='email'
							onChange={(name, value) => this.handleInput(name, value)}
							onKeyPress={this.handleKeyPress}
							type='email'
							value={email}
						/>
						<Input
							label='Password (6 or more chars.)'
							name='password'
							onChange={(name, value) => this.handleInput(name, value)}
							onKeyPress={this.handleKeyPress}
							type='password'
							value={password}
						/>
					</div>
				}

				{/* REGISTRATION */}
				{authProcess === 'registration' &&
					<div>
						<div className='capps-footer'>
							Already registered? <span onTouchTap={() => this.resetAuthProcess()} className='capps-link'>Try again</span> or <span onTouchTap={() => this.props.redux.nav.setPage('reset')} className='capps-link'>reset your password</span>. Otherwise, please signup below.
						</div>
						<Input
							label='Confirm password'
							name='passwordConfirm'
							onChange={(name, value) => this.handleInput(name, value)}
							onKeyPress={this.handleKeyPress}
							type='password'
							value={passwordConfirm}
						/>
						{passwordConfirm.length >= 6 && password !== passwordConfirm && <div className='capps-footer' style={{ color: '#FF0000', fontWeight: '400' }}>Password does not match</div>}
						{passwordConfirm.length >= 6 && password === passwordConfirm && <div className='capps-footer' style={{ color: '#008000', fontWeight: '400' }}>Password confirmed</div>}
						<div className='capps-flex-horiz-center'>
							<Input
								label='First name'
								name='nameFirst'
								onChange={(name, value) => this.handleInput(name, value)}
								onKeyPress={this.handleKeyPress}
								type='text'
								value={nameFirst}
							/>
							<Input
								label='Last name'
								name='nameLast'
								onChange={(name, value) => this.handleInput(name, value)}
								onKeyPress={this.handleKeyPress}
								type='text'
								value={nameLast}
							/>
						</div>
					</div>
				}

				{/* EMAIL CONFIRMATION */}
				{authProcess === 'confirm' &&
					<div className='capps-container'>
						<div className='capps-text'>Please check your email for an email confirmation link for this email:</div>
						<div className='capps-height-10' />
						<center><div style={{ color: '#008000', fontWeight: '400' }}>{email}</div></center>
						<div className='capps-height-10' />
						<div className='capps-text'>
							<strong>The confirmation link expires in one day.</strong>
						</div>
						<div className='capps-height-10' />
						<div className='capps-text'>If you entered an incorrect email address or don’t have access to it, please re-register using a different email address.</div>
						<div className='capps-height-20' />
					</div>
				}

				{/* MESSAGE */}
				<div className='capps-footer' style={{ color: message.color, fontWeight: '400' }}><center>{message.text}</center></div>

				{/* BUTTON */}
				{(authProcess === 'login' || authProcess === 'registration' || authProcess === 'confirm' || authProcess === 'confirmed') &&
					<div>
						<div className='capps-height-10' />
						<Button
							action={buttonFunc}
							disabled={!this.validation()}
							text={buttonText}
						/>
					</div>
				}

				{/* TOS & PRIVACY POLICY */}
				{(authProcess === 'registration' || authProcess === 'login') &&
					<div className='capps-footer'>
						By signing in, you agree to our <span onTouchTap={() => window.open('https://www.consciousapps.com/terms', '_system')} className='capps-link'>Terms</span> and <span onTouchTap={() => window.open('https://www.consciousapps.com/privacy', '_system')} className='capps-link'>Privacy Policy</span>.
					</div>
				}

				{/* ABOUT THE MOON SIGN APP */}
				{authProcess === 'login' &&
					<center>
						<div className='capps-height-20' />
						<div className='capps-footer' onTouchTap={() => {
							window.localStorage.setItem('MoonSignApp:welcome', true)
							this.props.redux.nav.setPage('login')
						}}>
							<span className='capps-link'>About the Moon Sign App</span>
						</div>
					</center>
				}
			</div>
		)
	}
}

export default compose(
	graphql(accountSignup, { name: 'accountSignup' }),
	graphql(accountAuthenticate, { name: 'accountAuthenticate' }),
	graphql(emailConfirm, { name: 'emailConfirm' }),
	graphql(emailConfirmAgain, { name: 'emailConfirmAgain' })
)(Signin)



// WEBPACK FOOTER //
// ./src/Components/Auth/Signin.js